import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

// role:----------------------------------------------------------------------

/**
 * 获取权限列表
 * @param {*} params
 * @returns
 */
export const RoleListAll = params => {
  return request('get', `${baseUrl}/api/auth/sys/permission/role/all`, params);
};

/**
 * 数据权限设置
 */
export const RoleDataAuth = data => {
  return request('post', `${baseUrl}/api/auth/sys/permission/role/auth/data`, data);
};

/**
 * 菜单权限设置
 */
export const RoleMenuAuth = data => {
  return request('post', `${baseUrl}/api/auth/sys/permission/role/auth/menu`, data);
};

/**
 * 删除角色
 */
export const RoleDelete = data => {
  return request('post', `${baseUrl}/api/auth/sys/permission/role/del`, data);
};

/**
 * 编辑角色
 */
export const RoleEdit = data => {
  return request('post', `${baseUrl}/api/auth/sys/permission/role/edit`, data);
};

/**
 * 角色详情
 */
export const RoleDetail = data => {
  return request('get', `${baseUrl}/api/auth/sys/permission/role/info`, data);
};

/**
 * 分页获取角色列表{apiNoUse}
 */
export const RoleListPage = data => {
  return request('get', `${baseUrl}/api/auth/sys/permission/role/page`, data);
};

/**
 * 新增角色
 */
export const RoleAdd = data => {
  return request('post', `${baseUrl}/api/auth/sys/permission/role/save`, data);
};

/**
 * 获取所有菜单/接口
 */
export const AllMenuInterface = data => {
  return request('get', `${baseUrl}/api/auth/sys/permission/role/compact`, data);
};

// menu:----------------------------------------------------------------------

/**
 * 获取所有菜单
 */
export const AllMenuList = data => {
  return request('get', `${baseUrl}/api/auth/sys/permission/menu/all`, data);
};

/**
 * 获取此菜单所有子菜单列表{apiNoUse}
 */
export const MenuChildList = data => {
  return request('get', `${baseUrl}/api/auth/sys/permission/menu/child`, data);
};

/**
 * 删除菜单
 */
export const MenuDelete = data => {
  return request('post', `${baseUrl}/api/auth/sys/permission/menu/del`, data);
};

/**
 * 获取此菜单详情
 */
export const MenuDetail = data => {
  return request('get', `${baseUrl}/api/auth/sys/permission/menu/detail`, data);
};

/**
 * 编辑菜单
 */
export const MenuEdit = data => {
  return request('post', `${baseUrl}/api/auth/sys/permission/menu/edit`, data);
};

/**
 * 新增菜单
 */
export const MenuAdd = data => {
  return request('post', `${baseUrl}/api/auth/sys/permission/menu/save`, data);
};

// interface:----------------------------------------------------------------------

/**
 * 删除接口
 */
export const InterfaceDel = data => {
  return request('post', `${baseUrl}/api/auth/sys/permission/interface/del`, data);
};

/**
 * 编辑接口
 */
export const InterfaceEdit = data => {
  return request('post', `${baseUrl}/api/auth/sys/permission/interface/edit`, data);
};

/**
 * 新增接口
 */
export const InterfaceAdd = data => {
  return request('post', `${baseUrl}/api/auth/sys/permission/interface/save`, data);
};

/**
 * 获取接口
 */
export const InterfaceDetail = data => {
  return request('get', `${baseUrl}/api/auth/sys/permission/interface/detail`, data);
};
